import React, { Component } from "react";
import { Redirect } from "react-router";
import styled from "styled-components";
import nota from "../../Global/nota.guidelines.json";
import NanoFlex from "../../Global/NanoFlex";
import Type from "../../Global/Typography.js";
import { Link } from "react-router-dom";
// import { ReactComponent as ErrorLogo } from "../../Global/Icons/erroLogo.svg";
//Images
import ErrorLogo from "../../Global/Icons/errorLogo.svg";

const multiple = nota.global.multiple;
const StyledErrorPage = styled(NanoFlex)`
  height: 100vh;
  background-color: ${nota.color.main.default};
  background-image: url(${ErrorLogo});
  background-repeat: no-repeat, repeat;
  background-size: auto 110%;
  .errorContainer {
    padding: 5% 10%;
    .errorInfoWrapper {
      .infoWrapper {
        height: auto;
        h1 {
          line-height: unset;
          b {
            font-size: 20vw;
            text-transform: uppercase;
            color: ${nota.color.neutral.white};
          }
        }
        h2 {
          line-height: unset;
          b {
            font-size: 6vw;
            color: ${nota.color.neutral.white};
          }
        }
        h3 {
          line-height: unset;
          b {
            font-size: 2vw;
            text-transform: uppercase;
            color: ${nota.color.neutral.white};
          }
        }
        h5 {
          width: 400px;
          text-align: right;
          font-size: 20px;
          line-height: 25px;
          color: ${nota.color.neutral.white};
        }
      }
    }
    .bottomInfo {
      height: auto;
      padding-top: 100px;
      h4 {
        color: ${nota.color.neutral.white};
        text-transform: uppercase;
        font-size: 15px;
        a {
          color: ${nota.color.neutral.white};
          text-decoration: none;
          font-weight: bold;
          &:hover {
            text-decoration: underline;
          }
        }
      }
    }
  }
  @media only screen and (max-width: ${nota.global.breakpoints.verticalTablet + "px"}) {
    /* height: auto; */
    min-height: 100%;
    background-size: cover;
    background-position: center;
    .errorContainer {
      padding: 10% 10%;
      .errorInfoWrapper {
        .infoWrapper {
          justify-content: center;
          align-items: center;
          h1 {
            b {
              font-size: 150px;
            }
          }
          h2 {
            b {
              font-size: 50px;
            }
          }
          h3 {
            text-align: center;
            b {
              font-size: 20px;
            }
          }
          h5 {
            width: auto;
            text-align: center;
            font-size: 15px;
          }
        }
      }
      .bottomInfo {
        /* padding-top:50px; */
        text-align: center;
      }
    }
  }
`;

export class Error404 extends Component {
  constructor(props) {
    super(props);
    this.state = { redirect: false };
  }

  homeClick() {
    this.setState({ redirect: true });
  }

  render() {
    if (this.state.redirect) return <Redirect to="/" />;
    return (
      <StyledErrorPage>
        <NanoFlex className="errorContainer" flexDirection={"column"}>
          <NanoFlex className="errorInfoWrapper" flexDirection={"column"} alignItems={"flex-end"}>
            <NanoFlex className="infoWrapper" justifyContent={"flex-end"} alignItems={"flex-end"}>
              <Type.h2>
                <b>Oops!</b>
              </Type.h2>
            </NanoFlex>
            <NanoFlex className="infoWrapper" justifyContent={"flex-end"} alignItems={"flex-end"}>
              <Type.h1>
                <b>404</b>
              </Type.h1>
            </NanoFlex>
            <NanoFlex className="infoWrapper" flexDirection={"column"} justifyContent={"flex-end"} alignItems={"flex-end"}>
              <Type.h3>
                <b>SOMETHING Went WRONG</b>
              </Type.h3>
              <Type.h5>The link you clicked may be broken or the page may have been removed.</Type.h5>
            </NanoFlex>
          </NanoFlex>

          <NanoFlex className="bottomInfo" alignItems={"flex-end"}>
            <Type.h4>
              Visit the <Link to="/">Homepage</Link> or <a href="mailto:e-nota@glance-mediametrie.com">Contact Us</a> About the problem
            </Type.h4>
          </NanoFlex>
        </NanoFlex>
      </StyledErrorPage>
    );
  }
}

{
}
